import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';

export class Home extends Component {
  render() {
    return (
      <h1>Home</h1>
    )
  }
}

const Styles = StyleSheet.create({

})



// WEBPACK FOOTER //
// ./src/screens/Home.js